//-------------------------
// generate combatant name
//-------------------------
export default function genCombatantName(name, type, index) {
  let return_name = "";

  if (type == "Troop") {
    return_name = name + index;
  } else {
    return_name = name;
  }
  return return_name;
}
